webpackJsonp([0],{

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App_js__ = __webpack_require__(248);




__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_App_js__["a" /* App */], null), document.getElementById('root'));

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Link */
/* unused harmony export Home */
/* unused harmony export Progress */
/* unused harmony export MixButton */
/* unused harmony export MixRow */
/* unused harmony export Scene */
/* unused harmony export PowerUp */
/* unused harmony export Warning */
/* unused harmony export Eating */
/* unused harmony export PowerDown */
/* unused harmony export SampleTree */
/* unused harmony export DayInTheLife */
/* unused harmony export NotFound */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_styl__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sounds__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__day_in_the_life_mp4__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__day_in_the_life_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__day_in_the_life_mp4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__favicon_ico__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__favicon_ico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__favicon_ico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__power_up_png__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__power_up_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__power_up_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__warning_png__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__warning_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__warning_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__eating_png__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__eating_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__eating_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__power_down_png__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__power_down_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__power_down_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__no_sound_png__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__no_sound_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__no_sound_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__chevron_png__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__chevron_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__chevron_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__chevron_yr_png__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__chevron_yr_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__chevron_yr_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__chevron_wr_png__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__chevron_wr_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__chevron_wr_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__powerUp_gif__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__powerUp_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__powerUp_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__warning_gif__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__warning_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__warning_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__eating_gif__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__eating_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__eating_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__powerDown_gif__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__powerDown_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__powerDown_gif__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// Using CSS Modules so we assign the styles to a variable

var cx = __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_2__App_styl___default.a);




// Favicon link is in the template, this just makes webpack package it up for us


// trash bot images
















var trashBots = {
  powerUp: {
    bot: __WEBPACK_IMPORTED_MODULE_6__power_up_png___default.a,
    anim: __WEBPACK_IMPORTED_MODULE_14__powerUp_gif___default.a,
    y: -357
  },
  warning: {
    bot: __WEBPACK_IMPORTED_MODULE_7__warning_png___default.a,
    anim: __WEBPACK_IMPORTED_MODULE_15__warning_gif___default.a,
    y: -357
  },
  eating: {
    bot: __WEBPACK_IMPORTED_MODULE_8__eating_png___default.a,
    anim: __WEBPACK_IMPORTED_MODULE_16__eating_gif___default.a,
    y: -461
  },
  powerDown: {
    bot: __WEBPACK_IMPORTED_MODULE_9__power_down_png___default.a,
    anim: __WEBPACK_IMPORTED_MODULE_17__powerDown_gif___default.a,
    y: -584
  }
};

var initialState = {
  uri: 'home',
  inactive: false,
  powerUp: {
    melody: null,
    ambience: null,
    effect: null
  },
  warning: {
    melody: null,
    ambience: null,
    effect: null
  },
  eating: {
    melody: null,
    ambience: null,
    effect: null
  },
  powerDown: {
    melody: null,
    ambience: null,
    effect: null
  }
};

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: this.props.className, onClick: function onClick(e) {
            return _this2.props.setUri(_this2.props.to);
          } },
        this.props.children
      );
    }
  }]);

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Home = function (_React$Component2) {
  _inherits(Home, _React$Component2);

  function Home() {
    _classCallCheck(this, Home);

    return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).apply(this, arguments));
  }

  _createClass(Home, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('client') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('home') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { margin: '50px', fontSize: '60px', fontWeight: '900' } },
            'WELCOME!'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { fontSize: '40px', fontWeight: '400' } },
            'Trash Bot is a street-cleaning machine.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { fontSize: '40px', fontWeight: '400' } },
            'What sounds should Trash Bot make during a day of work?'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Link,
          _extends({}, this.props, { to: 'power_up' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('start_designing_button') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              'Start Designing'
            )
          )
        )
      );
    }
  }]);

  return Home;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Progress = function (_React$Component3) {
  _inherits(Progress, _React$Component3);

  function Progress() {
    _classCallCheck(this, Progress);

    return _possibleConstructorReturn(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).apply(this, arguments));
  }

  _createClass(Progress, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      var styleFor = function styleFor(key) {
        return _this5.props.scene === key ? cx('progress-active') : cx('progress-inactive');
      };
      var chevronFor = function chevronFor(key, nextKey) {
        if (_this5.props.scene === key) {
          return __WEBPACK_IMPORTED_MODULE_12__chevron_yr_png___default.a;
        }
        if (_this5.props.scene === nextKey) {
          return __WEBPACK_IMPORTED_MODULE_13__chevron_wr_png___default.a;
        }
        return __WEBPACK_IMPORTED_MODULE_11__chevron_png___default.a;
      };
      var chevronStyle = {
        height: '85px',
        float: 'right',
        marginTop: '-20px'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('client-progress') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Link,
          _extends({}, this.props, { to: 'power_up', className: styleFor('powerUp') }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: chevronFor('powerUp', 'warning'), style: chevronStyle }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            '1. Power Up'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Link,
          _extends({}, this.props, { to: 'warning', className: styleFor('warning') }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: chevronFor('warning', 'eating'), style: chevronStyle }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            '2. Warning'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Link,
          _extends({}, this.props, { to: 'eating', className: styleFor('eating') }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: chevronFor('eating', 'powerDown'), style: chevronStyle }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            '3. Feed The Bot'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Link,
          _extends({}, this.props, { to: 'power_down', className: styleFor('powerDown') }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            '4. Power Down'
          )
        )
      );
    }
  }]);

  return Progress;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var MixButton = function (_React$Component4) {
  _inherits(MixButton, _React$Component4);

  function MixButton() {
    _classCallCheck(this, MixButton);

    return _possibleConstructorReturn(this, (MixButton.__proto__ || Object.getPrototypeOf(MixButton)).apply(this, arguments));
  }

  _createClass(MixButton, [{
    key: 'render',
    value: function render() {
      var _this7 = this;

      var styled = function styled() {
        return _this7.props.getSounds()[_this7.props.scene][_this7.props.channel] === _this7.props.sound ? cx('mix-target-selected', 'playable') : cx('mix-target', 'playable');
      };
      var playSample = function playSample() {
        _this7.props.setSound(_this7.props.scene, _this7.props.channel, _this7.props.sound);
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('mix-button') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: styled(),
            onClick: playSample },
          this.props.sound
        )
      );
    }
  }]);

  return MixButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var MixRow = function (_React$Component5) {
  _inherits(MixRow, _React$Component5);

  function MixRow() {
    _classCallCheck(this, MixRow);

    return _possibleConstructorReturn(this, (MixRow.__proto__ || Object.getPrototypeOf(MixRow)).apply(this, arguments));
  }

  _createClass(MixRow, [{
    key: 'play',
    value: function play() {
      var mixButton = this.props.getSounds()[this.props.scene][this.props.channel];
      if (mixButton) {
        this.refs[mixButton].play();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      var cancel = function cancel() {
        _this9.props.setSound(_this9.props.scene, _this9.props.channel, null);
      };
      var cancelButton = function cancelButton() {
        return _this9.props.getSounds()[_this9.props.scene][_this9.props.channel] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('mix-target', 'unplayable'), onClick: cancel },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_10__no_sound_png___default.a, style: { width: '40px', height: '40px' } })
        ) : null;
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('mix-row') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('mix-title') },
          this.props.prompt
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MixButton, _extends({ ref: 'a' }, this.props, { sound: 'a' })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MixButton, _extends({ ref: 'b' }, this.props, { sound: 'b' })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('mix-button') },
          cancelButton()
        )
      );
    }
  }]);

  return MixRow;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Scene = function (_React$Component6) {
  _inherits(Scene, _React$Component6);

  function Scene(props) {
    _classCallCheck(this, Scene);

    var _this10 = _possibleConstructorReturn(this, (Scene.__proto__ || Object.getPrototypeOf(Scene)).call(this, props));

    _this10.animate = function () {
      _this10.setState({ animating: true });
      setTimeout(function () {
        _this10.setState({ animating: false });
      }, 3000);
    };

    _this10.state = {
      animating: false
    };
    return _this10;
  }

  _createClass(Scene, [{
    key: 'render',
    value: function render() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('client') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Progress, _extends({}, this.props, { scene: this.props.scene })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('interactive-page') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('mix-column') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: cx('intro') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: cx('intro-text') },
                this.props.introText
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: cx('mixer') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MixRow, _extends({ ref: 'melody' }, this.props, { channel: 'melody', prompt: 'Choose A Melody' })),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MixRow, _extends({ ref: 'ambience' }, this.props, { channel: 'ambience', prompt: 'Choose An Ambience' })),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MixRow, _extends({ ref: 'effect' }, this.props, { channel: 'effect', prompt: 'Choose An Effect' }))
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: cx('play-area') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: cx('play-title') },
                'Your Sound Mix'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: cx('play') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: cx('play-target', 'play-mix'), onClick: function onClick(e) {
                      _this11.animate();
                      _this11.props.playMix(_this11.props.scene);
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: cx('play-arrow') }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: cx('play-legend') },
                    'Play'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  Link,
                  _extends({}, this.props, { to: this.props.nextSceneUri, className: cx('submit-target') }),
                  'Submit'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('speaker-column') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: cx('animation') },
              ' ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: trashBots[this.props.scene].anim, style: { marginTop: trashBots[this.props.scene].y, visibility: this.state.animating ? 'visible' : 'hidden' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: cx('speaker') },
              ' ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: trashBots[this.props.scene].bot })
            )
          )
        )
      );
    }
  }]);

  return Scene;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var PowerUp = function (_React$Component7) {
  _inherits(PowerUp, _React$Component7);

  function PowerUp() {
    _classCallCheck(this, PowerUp);

    return _possibleConstructorReturn(this, (PowerUp.__proto__ || Object.getPrototypeOf(PowerUp)).apply(this, arguments));
  }

  _createClass(PowerUp, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Scene, _extends({}, this.props, {
        introText: 'Mix three sounds for Trash Bot to play when powering up.',
        scene: 'powerUp',
        nextSceneUri: 'warning' }));
    }
  }]);

  return PowerUp;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Warning = function (_React$Component8) {
  _inherits(Warning, _React$Component8);

  function Warning() {
    _classCallCheck(this, Warning);

    return _possibleConstructorReturn(this, (Warning.__proto__ || Object.getPrototypeOf(Warning)).apply(this, arguments));
  }

  _createClass(Warning, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Scene, _extends({}, this.props, {
        introText: 'Mix three sounds for Trash Bot to play when approaching a cyclist.',
        scene: 'warning',
        nextSceneUri: 'eating' }));
    }
  }]);

  return Warning;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Eating = function (_React$Component9) {
  _inherits(Eating, _React$Component9);

  function Eating() {
    _classCallCheck(this, Eating);

    return _possibleConstructorReturn(this, (Eating.__proto__ || Object.getPrototypeOf(Eating)).apply(this, arguments));
  }

  _createClass(Eating, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Scene, _extends({}, this.props, {
        introText: 'Mix three sounds for Trash Bot to play after swallowing a piece of trash.',
        scene: 'eating',
        nextSceneUri: 'power_down' }));
    }
  }]);

  return Eating;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var PowerDown = function (_React$Component10) {
  _inherits(PowerDown, _React$Component10);

  function PowerDown() {
    _classCallCheck(this, PowerDown);

    return _possibleConstructorReturn(this, (PowerDown.__proto__ || Object.getPrototypeOf(PowerDown)).apply(this, arguments));
  }

  _createClass(PowerDown, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Scene, _extends({}, this.props, {
        introText: 'Mix three sounds for Trash Bot to play when it\'s time to go to sleep.',
        scene: 'powerDown',
        nextSceneUri: 'day_in_the_life' }));
    }
  }]);

  return PowerDown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var sceneList = ['powerUp', 'warning', 'eating', 'powerDown'];
var channelList = ['melody', 'ambience', 'effect'];
var soundList = ['a', 'b'];

var SampleTree = function (_React$Component11) {
  _inherits(SampleTree, _React$Component11);

  function SampleTree() {
    var _ref;

    var _temp, _this16, _ret;

    _classCallCheck(this, SampleTree);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this16 = _possibleConstructorReturn(this, (_ref = SampleTree.__proto__ || Object.getPrototypeOf(SampleTree)).call.apply(_ref, [this].concat(args))), _this16), _this16.playMix = function (scene, melody, ambience, effect) {
      var map = {
        melody: melody,
        ambience: ambience,
        effect: effect
      };
      var audios = [];
      channelList.map(function (channel) {
        var ref = scene + '_' + channel + '_' + map[channel];
        var audio = _this16.refs[ref];
        if (audio) {
          audios.push(audio);
        }
      });
      var prepare = function prepare(audio) {
        if (!audio.paused) {
          audio.pause();
        }
        if (audio.duration > 0) {
          audio.currentTime = 0;
        }
      };
      var play = function play(audio) {
        setTimeout(function () {
          return audio.play();
        }, 25);
      };
      audios.map(function (audio) {
        return prepare(audio);
      });
      audios.map(function (audio) {
        return play(audio);
      });
    }, _this16.play = function (scene, channel, sound) {
      var ref = scene + '_' + channel + '_' + sound;
      var audio = _this16.refs[ref];
      if (sound) {
        if (!audio.paused) {
          audio.pause();
        }
        if (audio.duration > 0) {
          audio.currentTime = 0;
        }
        setTimeout(function () {
          return audio.play();
        }, 25);
      }
    }, _this16.shouldComponentUpdate = function (nextProps, nextState) {
      // This component doesn't update
      return false;
    }, _this16.audioTags = function () {
      return sceneList.map(function (scene) {
        return channelList.map(function (channel) {
          return soundList.map(function (sound) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio', {
              ref: scene + '_' + channel + '_' + sound,
              src: __WEBPACK_IMPORTED_MODULE_3__sounds__["a" /* sounds */][scene][channel][sound],
              preload: 'auto'
            });
          });
        });
      });
    }, _temp), _possibleConstructorReturn(_this16, _ret);
  }

  _createClass(SampleTree, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.audioTags()
      );
    }
  }]);

  return SampleTree;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var DayInTheLife = function (_React$Component12) {
  _inherits(DayInTheLife, _React$Component12);

  function DayInTheLife(props) {
    _classCallCheck(this, DayInTheLife);

    var _this17 = _possibleConstructorReturn(this, (DayInTheLife.__proto__ || Object.getPrototypeOf(DayInTheLife)).call(this, props));

    _this17.state = {
      infoDisplay: 'block'
    };
    return _this17;
  }

  _createClass(DayInTheLife, [{
    key: 'render',
    value: function render() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('client') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('home') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { margin: '15px', marginBottom: '10px', fontSize: '60px', fontWeight: 900 } },
            'A DAY WITH TRASH BOT'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: this.state.infoDisplay } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontWeight: 400, fontSize: '40px' } },
              'This animation has the sounds that you designed.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontWeight: 400, fontSize: '40px' } },
              'Notice how your sounds support Trash Bot\u2019s actions and personality.'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { display: 'flex' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('play_movie_button'), style: { margin: '70px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: cx('play-target'), onClick: function onClick() {
                  _this18.setState({ infoDisplay: 'none' });
                  var video = _this18.refs.dayVideo;
                  if (video.duration > 0 && !video.paused) {
                    video.pause();
                    video.currentTime = 0;
                  }
                  video.play();
                  _this18.cancelable = _this18.cancelable || [];
                  _this18.cancelable.forEach(function (timeout) {
                    clearTimeout(timeout);
                  });
                  _this18.cancelable.push(setTimeout(function (e) {
                    return _this18.props.playMix('powerUp');
                  }, 5000));
                  _this18.cancelable.push(setTimeout(function (e) {
                    return _this18.props.playMix('warning');
                  }, 10000));
                  _this18.cancelable.push(setTimeout(function (e) {
                    return _this18.props.playMix('eating');
                  }, 15000));
                  _this18.cancelable.push(setTimeout(function (e) {
                    return _this18.props.playMix('powerDown');
                  }, 20000));
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: cx('play-anim-arrow') }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: cx('play-anim-legend') },
                'Play'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('start_over_button'), style: { margin: '70px', cursor: 'pointer' }, onClick: function onClick(e) {
                setTimeout(function (e) {
                  return window.location.reload(true);
                }, 100);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              'Start Over'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'video',
          { style: { width: '100%' }, ref: 'dayVideo', src: __WEBPACK_IMPORTED_MODULE_4__day_in_the_life_mp4___default.a, preload: 'auto' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source', {
            src: __WEBPACK_IMPORTED_MODULE_4__day_in_the_life_mp4___default.a,
            type: 'video/mp4' })
        )
      );
    }
  }]);

  return DayInTheLife;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var NotFound = function (_React$Component13) {
  _inherits(NotFound, _React$Component13);

  function NotFound() {
    _classCallCheck(this, NotFound);

    return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
  }

  _createClass(NotFound, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('page') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          'Not found'
        )
      );
    }
  }]);

  return NotFound;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/**
 * NOTE: As of 2015-11-09 react-transform does not support a functional
 * component as the base compoenent that's passed to ReactDOM.render, so we
 * still use createClass here.
 */
var App = function (_React$Component14) {
  _inherits(App, _React$Component14);

  function App(props) {
    _classCallCheck(this, App);

    var _this20 = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    _this20.setUri = function (uri) {
      _this20.touchTimeout();
      _this20.setState({
        uri: uri
      });
    };

    _this20.setSound = function (scene, channel, sound) {
      _this20.touchTimeout();
      var change = _extends({}, _this20.state[scene]);
      change[channel] = sound;
      var stateChange = {};
      stateChange[scene] = change;
      if (sound !== null) {
        _this20.refs.sampleTree.play(scene, channel, sound);
      }
      _this20.setState(stateChange);
    };

    _this20.getSounds = function () {
      return _this20.state;
    };

    _this20.playMix = function (scene) {
      _this20.touchTimeout();
      _this20.refs.sampleTree.playMix(scene, _this20.state[scene].melody, _this20.state[scene].ambience, _this20.state[scene].effect);
    };

    _this20.handleInactivity = function () {
      if (_this20.state.uri === 'home') {
        // no-op on the home page,
        _this20.inactivity = setTimeout(_this20.handleInactivity, 10000);
        return;
      }
      if (_this20.state.inactive) {
        // ok, you're done
        window.location.reload();
      } else {
        _this20.setState({ inactive: true });
        // shorter timer to go away
        _this20.inactivity = setTimeout(_this20.handleInactivity, 10000);
      }
    };

    _this20.touchTimeout = function () {
      if (_this20.inactivity) {
        clearTimeout(_this20.inactivity);
      }
      _this20.inactivity = setTimeout(_this20.handleInactivity, 60000);
    };

    _this20.state = initialState;
    _this20.touchTimeout();
    return _this20;
  }

  _createClass(App, [{
    key: 'getScene',
    value: function getScene() {
      var props = {
        setSound: this.setSound,
        setUri: this.setUri,
        getSounds: this.getSounds,
        resetSounds: this.resetSounds,
        playMix: this.playMix
      };
      switch (this.state.uri) {
        case 'home':
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home, props);
        case 'power_up':
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PowerUp, props);
        case 'warning':
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Warning, props);
        case 'eating':
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Eating, props);
        case 'power_down':
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PowerDown, props);
        case 'day_in_the_life':
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DayInTheLife, props);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.state.inactive ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('inactivity'), onClick: function onClick(e) {
              _this21.setState({ inactive: false });
              _this21.touchTimeout();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            'Are you still there?'
          )
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SampleTree, { ref: 'sampleTree' }),
        this.getScene()
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TB_Eating_Melody_A_wav_mp3__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TB_Eating_Melody_A_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TB_Eating_Melody_A_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TB_Eating_Melody_B_wav_mp3__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TB_Eating_Melody_B_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TB_Eating_Melody_B_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TB_Eating_Ambience_A_wav_mp3__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TB_Eating_Ambience_A_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TB_Eating_Ambience_A_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TB_Eating_Ambience_B_wav_mp3__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TB_Eating_Ambience_B_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TB_Eating_Ambience_B_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TB_Eating_SFX_A_wav_mp3__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TB_Eating_SFX_A_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TB_Eating_SFX_A_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TB_Eating_SFX_B_wav_mp3__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TB_Eating_SFX_B_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TB_Eating_SFX_B_wav_mp3__);







/* harmony default export */ __webpack_exports__["a"] = ({
  melody: {
    a: __WEBPACK_IMPORTED_MODULE_0__TB_Eating_Melody_A_wav_mp3___default.a,
    b: __WEBPACK_IMPORTED_MODULE_1__TB_Eating_Melody_B_wav_mp3___default.a
  },
  ambience: {
    a: __WEBPACK_IMPORTED_MODULE_2__TB_Eating_Ambience_A_wav_mp3___default.a,
    b: __WEBPACK_IMPORTED_MODULE_3__TB_Eating_Ambience_B_wav_mp3___default.a
  },
  effect: {
    a: __WEBPACK_IMPORTED_MODULE_4__TB_Eating_SFX_A_wav_mp3___default.a,
    b: __WEBPACK_IMPORTED_MODULE_5__TB_Eating_SFX_B_wav_mp3___default.a
  }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sounds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__power_up___ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning___ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eating___ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__power_down___ = __webpack_require__(251);





var sounds = {
  powerUp: __WEBPACK_IMPORTED_MODULE_0__power_up___["a" /* default */],
  warning: __WEBPACK_IMPORTED_MODULE_1__warning___["a" /* default */],
  eating: __WEBPACK_IMPORTED_MODULE_2__eating___["a" /* default */],
  powerDown: __WEBPACK_IMPORTED_MODULE_3__power_down___["a" /* default */]
};

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TB_Powerdown_Melody_A_wav_mp3__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TB_Powerdown_Melody_A_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TB_Powerdown_Melody_A_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TB_Powerdown_Melody_B_wav_mp3__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TB_Powerdown_Melody_B_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TB_Powerdown_Melody_B_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TB_Powerdown_Ambience_A_wav_mp3__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TB_Powerdown_Ambience_A_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TB_Powerdown_Ambience_A_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TB_Powerdown_Ambience_B_wav_mp3__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TB_Powerdown_Ambience_B_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TB_Powerdown_Ambience_B_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TB_Powerdown_SFX_A_wav_mp3__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TB_Powerdown_SFX_A_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TB_Powerdown_SFX_A_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TB_Powerdown_SFX_B_wav_mp3__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TB_Powerdown_SFX_B_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TB_Powerdown_SFX_B_wav_mp3__);







/* harmony default export */ __webpack_exports__["a"] = ({
  melody: {
    a: __WEBPACK_IMPORTED_MODULE_0__TB_Powerdown_Melody_A_wav_mp3___default.a,
    b: __WEBPACK_IMPORTED_MODULE_1__TB_Powerdown_Melody_B_wav_mp3___default.a
  },
  ambience: {
    a: __WEBPACK_IMPORTED_MODULE_2__TB_Powerdown_Ambience_A_wav_mp3___default.a,
    b: __WEBPACK_IMPORTED_MODULE_3__TB_Powerdown_Ambience_B_wav_mp3___default.a
  },
  effect: {
    a: __WEBPACK_IMPORTED_MODULE_4__TB_Powerdown_SFX_A_wav_mp3___default.a,
    b: __WEBPACK_IMPORTED_MODULE_5__TB_Powerdown_SFX_B_wav_mp3___default.a
  }
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TB_Powerup_Melody_A_wav_mp3__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TB_Powerup_Melody_A_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TB_Powerup_Melody_A_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TB_Powerup_Melody_B_wav_mp3__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TB_Powerup_Melody_B_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TB_Powerup_Melody_B_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TB_Powerup_Ambience_A_wav_mp3__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TB_Powerup_Ambience_A_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TB_Powerup_Ambience_A_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TB_Powerup_Ambience_B_wav_mp3__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TB_Powerup_Ambience_B_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TB_Powerup_Ambience_B_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TB_Powerup_SFX_A_wav_mp3__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TB_Powerup_SFX_A_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TB_Powerup_SFX_A_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TB_Powerup_SFX_B_wav_mp3__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TB_Powerup_SFX_B_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TB_Powerup_SFX_B_wav_mp3__);







/* harmony default export */ __webpack_exports__["a"] = ({
  melody: {
    a: __WEBPACK_IMPORTED_MODULE_0__TB_Powerup_Melody_A_wav_mp3___default.a,
    b: __WEBPACK_IMPORTED_MODULE_1__TB_Powerup_Melody_B_wav_mp3___default.a
  },
  ambience: {
    a: __WEBPACK_IMPORTED_MODULE_2__TB_Powerup_Ambience_A_wav_mp3___default.a,
    b: __WEBPACK_IMPORTED_MODULE_3__TB_Powerup_Ambience_B_wav_mp3___default.a
  },
  effect: {
    a: __WEBPACK_IMPORTED_MODULE_4__TB_Powerup_SFX_A_wav_mp3___default.a,
    b: __WEBPACK_IMPORTED_MODULE_5__TB_Powerup_SFX_B_wav_mp3___default.a
  }
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TB_Warning_Melody_A_wav_mp3__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TB_Warning_Melody_A_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TB_Warning_Melody_A_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TB_Warning_Melody_B_wav_mp3__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TB_Warning_Melody_B_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TB_Warning_Melody_B_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TB_Warning_Ambience_A_wav_mp3__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TB_Warning_Ambience_A_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TB_Warning_Ambience_A_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TB_Warning_Ambience_B_wav_mp3__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TB_Warning_Ambience_B_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TB_Warning_Ambience_B_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TB_Warning_SFX_A_wav_mp3__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TB_Warning_SFX_A_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__TB_Warning_SFX_A_wav_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TB_Warning_SFX_B_wav_mp3__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TB_Warning_SFX_B_wav_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TB_Warning_SFX_B_wav_mp3__);







/* harmony default export */ __webpack_exports__["a"] = ({
  melody: {
    a: __WEBPACK_IMPORTED_MODULE_0__TB_Warning_Melody_A_wav_mp3___default.a,
    b: __WEBPACK_IMPORTED_MODULE_1__TB_Warning_Melody_B_wav_mp3___default.a
  },
  ambience: {
    a: __WEBPACK_IMPORTED_MODULE_2__TB_Warning_Ambience_A_wav_mp3___default.a,
    b: __WEBPACK_IMPORTED_MODULE_3__TB_Warning_Ambience_B_wav_mp3___default.a
  },
  effect: {
    a: __WEBPACK_IMPORTED_MODULE_4__TB_Warning_SFX_A_wav_mp3___default.a,
    b: __WEBPACK_IMPORTED_MODULE_5__TB_Warning_SFX_B_wav_mp3___default.a
  }
});

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 465:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"client":"_17KEMomS","home":"E92y4B1e","start_designing_button":"s119Q6Td","start_over_button":"_1CyoyJXD","client-progress":"_3ZqznMKH","progress-active":"mFiXtU97","progress-inactive":"_1iexjOPy","completed":"_1pUDNmwG","uncompleted":"_8_FKbOo7","interactive-page":"_1q816TnU","speaker-column":"_3WEauaQb","mix-column":"_2vtv3pl3","intro":"_2SE_CEnk","intro-header":"_2Uz0jtdD","intro-text":"_3RTakige","mixer":"_2wYyFA0d","mix-row":"_1HKIHCXj","mix-title":"ZJBSOUL9","mix-button":"QJK977cw","mix-target":"_3nTt7nH3","mix-target-selected":"_22XJuIlc","play-arrow":"_1f2WALET","play-anim-arrow":"_1zdXzbAq","play-area":"_1etRUrPq","play-title":"_1-wro5IC","play":"qb5367Aq","play-target":"_2M21HbYq","play-legend":"rDR2VJLe","play-anim-legend":"smy0a5R0","submit-target":"Z49QPqbd","speaker":"_1N3hic87","animation":"_3mTgRE2w","inactivity":"_5x3DM_gr"};

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "chevron-wr.1ac2bae5.png";

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "chevron-yr.697facb0.png";

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "chevron.c66be0bb.png";

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "day_in_the_life.3ced4b40.mp4";

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eating.bae6161c.gif";

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eating.392cdf3b.png";

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "favicon.fd73a6eb.ico";

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "no_sound.8b989f2c.png";

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "powerDown.6bb359d1.gif";

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "powerUp.222b8e31.gif";

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "power_down.ec9af3ff.png";

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "power_up.4c81cffa.png";

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Eating_Ambience_A.wav.034bd3c6.mp3";

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Eating_Ambience_B.wav.2395a907.mp3";

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Eating_Melody_A.wav.81f2b5dc.mp3";

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Eating_Melody_B.wav.89fb82fe.mp3";

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Eating_SFX_A.wav.e10d45f4.mp3";

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Eating_SFX_B.wav.07b93529.mp3";

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Powerdown_Ambience_A.wav.87673fd5.mp3";

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Powerdown_Ambience_B.wav.9f380771.mp3";

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Powerdown_Melody_A.wav.b5343875.mp3";

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Powerdown_Melody_B.wav.7453ed0d.mp3";

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Powerdown_SFX_A.wav.fb03fa77.mp3";

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Powerdown_SFX_B.wav.748d1d4b.mp3";

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Powerup_Ambience_A.wav.a9e2a745.mp3";

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Powerup_Ambience_B.wav.2f1e93d3.mp3";

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Powerup_Melody_A.wav.2afb4981.mp3";

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Powerup_Melody_B.wav.50a82b86.mp3";

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Powerup_SFX_A.wav.437aca31.mp3";

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Powerup_SFX_B.wav.d5264b42.mp3";

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Warning_Ambience_A.wav.52ef0b56.mp3";

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Warning_Ambience_B.wav.b4c58a0e.mp3";

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Warning_Melody_A.wav.80750997.mp3";

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Warning_Melody_B.wav.660677da.mp3";

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Warning_SFX_A.wav.4991e452.mp3";

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TB_Warning_SFX_B.wav.3d5d6663.mp3";

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "warning.706f5c69.gif";

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "warning.6337ff62.png";

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(109);
module.exports = __webpack_require__(244);


/***/ })

},[624]);


// WEBPACK FOOTER //
// app.0d5d62cc.js